import TargetTable from 'components/tables/target/TargetTable'
import React from 'react'

const index = () => {
    return (
        <TargetTable />
    )
}

export default index